//import "babel-polyfill";
import "vite/modulepreload-polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "iframe-resizer/js/iframeResizer";
import "simplebar";
import "./js/inert.min.js";
import "./js/smoothscroll.min.js";
import "./js/swipehandler.js";
import "./js/lazyload.js";
import "./js/page-navigation.js";
import "../Transportforetagen.Web/Blocks/ContactOptionBlock/contact-option.js";
import "./js/rich-text-table.js";
import "./js/analytics.js";
import "./js/header.js";
import "./js/paginator.js";
import "../Transportforetagen.Web/Blocks/QuoteCarouselListBlock/quote-carousel.js";
import "../Transportforetagen.Web/Blocks/PageListCarouselBlock/page-list-carousel.js";
import epiforms from "./js/epiforms.js";
import "../Transportforetagen.Web/Blocks/TextBlock/text-block.js";
import "../Transportforetagen.Web/Blocks/GuideListBlock/guide-list-block.js";
import "../Transportforetagen.Web/Blocks/FaqBlock/faq-item.js";
import "./js/favourite.js";
import "./js/branch-selector.js";
import "./js/dropdown.js";
import "../Transportforetagen.Web/Pages/Search/search.js";
import "./js/combobox.js";
import "./js/megamenu.js";
import "../Transportforetagen.Web/Pages/FavoritesPage/favorite-page.js";
import "../Transportforetagen.Web/Pages/Password/password.js";
import "../Transportforetagen.Web/Pages/CreateMember/create-member.js";
import "../Transportforetagen.Web/Pages/ProfilePage/profile.js";
import "../Transportforetagen.Web/Pages/ProfilePage/membersubmit.js";
import "./js/login.js";
import "./js/logout.js";
import "../Transportforetagen.Web/Pages/IssuesWeArePushing/issues-we-are-pushing.js";
import "../Transportforetagen.Web/Pages/Products/Behaviour/productslist.js";

import "../Transportforetagen.Web/Pages/ShopProductListPage/product-list.js";
import "../Transportforetagen.Web/Pages/ShopCheckoutPage/shop-checkout.js";
import "../Transportforetagen.Web/Pages/ShopCheckoutPage/shop-checkout-analytics.js";
import "../Transportforetagen.Web/Pages/Products/product-datalayer-events.js";
import "./js/expandandcollapse.js";
import "./js/related-talks.js";
import "../Transportforetagen.Web/Pages/EventTemplate/internal-booking.js";
import "../Transportforetagen.Web/Blocks/StartPageHeroBlock/start-hero.js";
import "../Transportforetagen.Web/Blocks/CampaignTimelineBlock/campaign-timeline.js";
import "../Transportforetagen.Web/Blocks/HeroBlock/hero.js";
import "../Transportforetagen.Web/Blocks/BranchEntryListBlock/branch-entry-list.js";
import "../Transportforetagen.Web/Blocks/CardsBlock/cards.js";
import "../Transportforetagen.Web/Blocks/TimeLineBlock/timeline.js";
import "../Transportforetagen.Web/Blocks/ProjectsListBlock/projects-list-block.js";
import "../Transportforetagen.Web/Blocks/CareerHeroBlock/career-hero.js";
import "../Transportforetagen.Web/Blocks/EmployerTestimonialsListBlock/employer-testimonials-list.js";
import "../Transportforetagen.Web/Blocks/AvailablePositionsListBlock/available-positions-list-block.js";
import "../Transportforetagen.Web/Blocks/BenefitsListBlock/benefits-list-block.js";
import "../Transportforetagen.Web/Blocks/HorizontalStepsBlock/horizontal-steps-list-block.js";
import "../Transportforetagen.Web/Blocks/RegionalOfficesBlock/regional-offices-block.js";
import "../Transportforetagen.Web/Blocks/OurCampaignsBlock/our-campaigns.js";
import "../Transportforetagen.Web/Blocks/EventsBlock/event-block.js";
import "../Transportforetagen.Web/Pages/EventListPage/eventlistpage.js";
import "../Transportforetagen.Web/Blocks/FilteredEventCarouselBlock/event-carousel.js";
import "../Transportforetagen.Web/Pages/FindMemberOrganisation/js/find-member-organisation.js";
import "../Transportforetagen.Web/Pages/EmployerGuide/guide.js";
import "../Transportforetagen.Web/Pages/EmployerGuideSubject/guide-subject.js";
import "../Transportforetagen.Web/Blocks/NumberBlock/number-block.js";
import "../Transportforetagen.Web/Blocks/RecruitmentProcessBlock/recruitment-process.js";
import "../Transportforetagen.Web/Blocks/CTAHeroBlock/ctaheroblock.js";
import "../Transportforetagen.Web/Blocks/ContactButtonBlock/contact-button.js";
import "../Transportforetagen.Web/Blocks/ExpandableContactButtonBlock/expandable-contact-button.js";
import "../Transportforetagen.Web/Blocks/PageListCarouselBlock/page-list-video-player.js";
import "../Transportforetagen.Web/Pages/CampaignPage/campaign-datalayer-events.js";
import "./js/branch-selector-events.js";
import "../Transportforetagen.Web/Pages/ContactSearch/contact-search.js";
import "../Transportforetagen.Web/Pages/ContactSearch/contact-search-analytics.js";
import "../Transportforetagen.Web/Pages/EmployerGuideSearch/guide-analytics.js";
import "../Transportforetagen.Web/Pages/NewsListPage/news-list-page.js";
import "../Transportforetagen.Web/Pages/NewsListPage/news-list-analytics.js";
import "./js/pills.js";
import "./js/breadcrumb.js";
import "../Transportforetagen.Web/Pages/TransportFacts/Views/Partials/SubNavigationMenu/sub-navigation-menu.js";
import "../Transportforetagen.Web/Blocks/MembershipFee/MembershipFeeAnalytics.js";
import "../Transportforetagen.Web/Blocks/HighlightBlock/highlight-video.js";
import "./js/tooltip.js";
import "./js/dropdown-link-list.js";
import "../Transportforetagen.Web/Blocks/SourceReferenceBlock/source-reference.js";
import "../Transportforetagen.Web/Blocks/EventFilterListBlock/event-filter-list.js";
import "../Transportforetagen.Web/Blocks/EventsBlock/manual-events-carousel.js";
import "../Transportforetagen.Web/Blocks/FocusAreasVideoBlock/focus-area-video.js";
import "../Transportforetagen.Web/Blocks/TinyMceVideoBlock/tinymce-video.js";
import "../Transportforetagen.Web/Blocks/LinkBlock/link-block.js";
import "../Transportforetagen.Web/Pages/EmbedPage/embed-page.js";
import "../Transportforetagen.Web/Pages/MembershipApplicationPage/membership-application.js";
import "../Transportforetagen.Web/Blocks/MembershipUspListBlock/membership-usp-list-video-player";
import "../Transportforetagen.Web/Blocks/EmployerGuideLoginSearchBlock/employer-guide-login-search.js";
import "../Transportforetagen.Web/Blocks/CTABlock/cta-block.js";
import "../Transportforetagen.Web/Blocks/HeroBlock/hero.js";
import "./js/share.js";
import "../Transportforetagen.Web/Blocks/LightboxGalleryBlock/lightbox-gallery.js";
import "../Transportforetagen.Web/Blocks/ExpandableFactsBlock/expandable-facts.js";
import "../Transportforetagen.Web/Blocks/ListPageLinksBlock/list-page-links.js";
import "./js/epiforms-helper";
import "../Transportforetagen.Web/Blocks/LockableModalLinkBlock/lockable-modal-link.js";
import "./js/dynamic-youtube-gtm-tracking";
import "./js/member-properties.js";
import "./app.css.js";
import "./js/link-helpers.js";
import "../Transportforetagen.Web/Blocks/ContentBlock/content-block.js";
import "../Transportforetagen.Web/Blocks/EventSubjectsBlock/event-subjects.js";
import "../Transportforetagen.Web/Blocks/EditorialEventExcerptCarouselBlock/editorial-carousel.js";
import "../Transportforetagen.Web/Blocks/CardBlock/campaign-card-with-video.js";
import "./js/event-analytics.js";

window.onload = () => {
	epiforms();
};
